import { GET_SESSION_API } from '../commons/constants';
import { AgentTypes } from '../types/agent.type';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchAgentsApi = async (request: {
  keyword?: string;
}): Promise<PaginationResponseTypes<AgentTypes[]>> => {
  let res: any;
  try {
    res = await get(`${GET_SESSION_API}/get-users-allow-sell-rent-chp`, {
      params: { ...request },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
